import { Switch as SwitchAD } from "antd";
import React, { useContext } from "react";

import { PPressComponentProps, PpressContext, PPressContextParams } from "../context";

type PPressSwitchProps = {
  className?: string;
  size?: "small" | "default";
  name: string;
} & PPressComponentProps;

export const Switch: React.FC<PPressSwitchProps> = props => {
  const { name, triggersOnChange, updateFromServerOnChange, size } = props;

  const formState = useContext(PpressContext) as PPressContextParams;
  const { ppress_params: params } = formState;

  return (
    <SwitchAD
      checked={params[name]}
      size={size}
      className={props.className}
      onChange={async () => {
        if (updateFromServerOnChange) {
          await formState.updateFormFromServer({
            ...params,
            [name]: !params[name],
          });
        } else {
          formState.updatePPressParams({
            [name]: !params[name],
          });

          if (triggersOnChange) {
            formState.triggersOnChange(triggersOnChange);
          }
        }
      }}
      data-test-id={`ppress-switch-${name}`}
    />
  );
};
